import {mapState} from 'vuex';
import 'firebase/storage';
import {v4 as uuidv4} from 'uuid';
import {EventsTypes} from '@/enums/EventsTypes';
import {optimizePhotos, uploadImage} from '@/utils/upload-image';
import {fileSizeToMB, validFileSize10MB} from "@/utils/fileSizeToMB";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import TimePicker from '@/components/pickers/TimePicker.vue';
import moment from 'moment';
import {
    RecurringEventsType,
    RecurringRepeatOnDay,
    RecurringRepeatOnNumber,
    RecurringRepeatType,
} from '@/enums/RecurringEventsType';
import {EventsTypesOptions} from '@/consts/EventsTypesOptions';
import {EventsTypesMinor} from '@/enums/EventsTypesMinor';
import CoolLightBox from 'vue-cool-lightbox'
import {EditRecurringEventTypes} from '@/enums/EditRecurringEventTypes';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import Loader from "@/components/loader/Loader.vue";
import firebase from "firebase/app";
import {dateFormats} from '@/consts/DateTimeFormats';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import {convertTimeDurationTo24hFormat, convertTimeTo24HourInArray, setTimeForDate} from '@/utils/dateTimeFormat';
import {ResidentStatus} from "@/enums/ResidentStatus";
import {EventLocations} from "@/enums/EventLocations";
import {toTranslationKey} from '@/utils/stringFormat';
import {Week} from "@/consts/Week";
import {PremiumServiceParticipantsLimit} from "@/enums/PremiumServiceParticipantsLimit";
import TimeRangeDropdown from "@/components/pickers/TimeRangeDropdown.vue";
import {PremiumServiceEventTypes} from '@/enums/PremiumServiceEventTypes';
import ScheduledPublishEventsDialog from "@/views/calender/view-calendar-item/ScheduledPublishEventsDialog.vue";
import i18n from "@/plugins/vueI18n";
import {EventLocationsMixin} from "@/mixins/EventLocations";
import EditRecurringEventDialog from "@/views/calender/view-calendar-item/EditRecurringEventDialog.vue";
import PublishEventToWingDialog from "@/views/calender/view-calendar-item/PublishEventToWingDialog.vue";
import GalleryPhotosUploadDlg from "@/views/staff/gallery/GalleryPhotosUploadDlg/GalleryPhotosUploadDlg.vue";
import CancelCallDialog from "@/views/calender/view-calendar-item/CancelCallDialog.vue";
import {delay, waitResizedImage} from '@/utils/wait-resized-image';
import {GalleryImage} from "@/models/GalleryImage";

/**
 * Don't change 'YYYY-MM-DD' format to a facility.dateFormat if a variable uses in v-date-picker control.
 * Store time in calendar.duration field in 24h time format (21:50-22-50).
 */

export default {
    name: 'CreateCalendarEvent',
    mixins: [EventLocationsMixin],
    components: {
        VueTimepicker,
        TimePicker,
        ConfirmDlg,
        CoolLightBox,
        Loader,
        EditRecurringEventDialog,
        PublishEventToWingDialog,
        TimeRangeDropdown,
        GalleryPhotosUploadDlg,
        ScheduledPublishEventsDialog,
        CancelCallDialog
    },
    data: () => ({
        menu1: false,
        menu2: false,
        menu3: false,
        viewEvent: {},
        viewEventCopy: null,
        eventImageUploadPerc: 100,
        selectedAttendees: [],
        flexHeight: 500,
        readonly: true,
        newEventVideoLink: null,
        recurringType: RecurringEventsType,
        recurringRepeatType: RecurringRepeatType,
        recurringTypes: Object.values(RecurringEventsType).map(x => ({text: toTranslationKey(x), value: x})),
        recurringRepeatTypes: Object.values(RecurringRepeatType).map(x => ({text: toTranslationKey(x), value: x})),
        startRecurringDate: null,
        endRecurringDate: null,
        recurringDurationVal: null,
        durationVal: null,
        upcomingRecurringEvents: [],
        minDate: moment(new Date()).format('YYYY-MM-DD'), //today
        maxDate: moment(new Date()).add(1, "year").format("YYYY-MM-DD"),
        hintDateHormat: '',
        hintTimeHormat: '',
        eventsTypes: EventsTypes,
        EventsTypesOptions: [],
        galeryImgLoading: false,
        startDateValid: true,
        endDateValid: true,
        endMaxDateValid: true,
        startDateTimeValid: true,
        endDateTimeValid: true,
        editRecurringEventTypes: EditRecurringEventTypes,
        editRecurringEventType: null,
        loading: true,
        saving: false,
        indexGalleryPhoto: null,
        isOpenEditRecurringEventOptionsDialog: false,
        isOpenCancelCallDialog: false,
        isDeleteRecurring: false,
        isDuplicateRecurring: false,
        isEditRecurring: false,
        week: Week,
        isTimeRangeValid: true,
        premiumServiceParticipantsLimit: PremiumServiceParticipantsLimit,
        newWingName: '',
        newLocationName: '',
        isOpenEventPhotoGallery: false,
        isOpenScheduldEventsDialog: false,
        isLoadingMeetingTimes: false,
        isLoadingMsCalendarEvents: false,
        isOffice365Event: false,
        isLoadedMsCalendarEvents: false,
        eventDates: [],
        busyEventDates: [],
        msCalendarEvents: [],
        durationMins: 15,
        availableTimes: [],
        startTime: null,
        currentRoomLocation: null,
        prevLocation: null,
        newLocation: null,
        recurringMeetingTimeSlot: '',
        isMsEventHourDurationInitialized: false,
        showAllAttendeesResidents: false,
        recurringRepeatOnNumbers: Object.values(RecurringRepeatOnNumber).map(x => ({text: toTranslationKey(x), value: x})),
        recurringRepeatOnDays: Object.values(RecurringRepeatOnDay).map(x => ({text: toTranslationKey(x), value: x})),
    }),

    computed: {
        ...mapState({
            calendarEvent() {
                return this.$store.state.calenderModule.currentCalenderEvent;
            },
            calendarRecurringEvents() {
                return this.$store.state.calenderModule.currentCalenderRecurringEvents;
            },
            recurringEventsUpdated() {
                return this.$store.state.calenderModule.recurringEventsUpdated;
            },
            socialClubsDropdown() {
                return this.$store.state.socialClubModule.socialClubsDropdown;
            },
            calendarEvents() {
                return this.$store.state.calenderModule.calenderEvents;
            },
            residents() {
                return this.$store.state.residentModule.residentsShortData;
            }, // todo filter out ones already on there.
            currentFacility() {
                return this.$store.state.authModule.currentFacility;
            },
            currentUserId() {
                return this.$store.state.authModule.user.id
            },
            additionalServices() {
                return this.$store.state.additionalServicesModule.additionalServices;
            },
            additionalService() {
                return this.additionalServices.find(x => x.id === this.calendarEvent.invitees[0]) ?? null;
            },
            facility() {
                return this.$store.state.facilityModule.selectedFacility;
            },
            EventsTypesMinor() {
                return EventsTypesMinor;
            },
            PremiumServiceEventTypes() {
                return PremiumServiceEventTypes;
            },
            eventLocations() {
                return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type !== EventLocations.Wing).map(x => ({
                    name: x.name,
                    value: x.name,
                    type: x.type,
                    isInOffice365: x.isInOffice365
                }))
            },
            isEventLocationsIncludesLocationEvent() {
                return this.$store.state.eventLocationModule.eventLocations.find(x => x.name === this.location);
            },
            locations() {
                return this.$store.state.eventLocationModule.eventLocations;
            },
            isEventWingsIncludesWingEvent() {
                return this.$store.state.eventLocationModule.eventLocations.find(x => x.name === this.wing) ?? this.wing === this.$t('GeneralTranslations.All') ?? this.wing === null ?? this.wing === '';
            },
            familyMembers() {
                return this.$store.state.residentModule.familyMembers;
            },
            isEnableRoomBooking() {
                return this.$store.state.facilityModule.selectedFacility.isEnableRoomBooking;
            },
            scheduledCallMembers() {
                const resident = this.residents.filter(resident =>
                    this.calendarEvent.going?.includes(resident.id)
                );

                const residents = this.residents.filter(resident =>
                    this.calendarEvent.invitees?.includes(resident.id)
                );

                const family = this.familyMembers.filter(familyMember =>
                    this.calendarEvent.familyGoing?.includes(familyMember.id)
                );

                const createdBy = this.calendarEvent.createdByFamilyUserId
                    ? this.calendarEvent.createdByFamilyUserId
                    : this.calendarEvent.createdByResidentId;

                return {
                    members: [...resident, ...family, ...residents],
                    createdBy,
                };
            },
            realtimeCallsMembers() {
                let resident;
                let family;

                if (this.calendarEvent.createdByFamilyUserId) {
                    resident = this.residents.filter(resident => this.calendarEvent.invitees.includes(resident.id));
                    family = this.familyMembers.filter(familyMember => familyMember.id === this.calendarEvent.createdByFamilyUserId);
                } else {
                    resident = this.residents.filter(resident => resident.id === this.calendarEvent.createdByResidentId);
                    family = this.familyMembers.filter(familyMember => this.calendarEvent.familyCallInvitees.includes(familyMember.id));
                }

                const createdBy = this.calendarEvent.createdByFamilyUserId
                    ? this.calendarEvent.createdByFamilyUserId
                    : this.calendarEvent.createdByResidentId;

                return {
                    members: [...resident, ...family],
                    createdBy
                };
            }
        }),
        isVisibleResidentInviteResponse() {
            return (
                this.facility.isOptInLifestylePrograms &&
                this.calendarEvent.type !== EventsTypesMinor.ScheduledCall &&
                this.calendarEvent.type !== EventsTypes.ConciergeRequest
            );
        },

        startDate: {
            set(value) {
                const startDate = moment(value).toDate();
                setTimeForDate(startDate, this.duration.split('-')[0])
                this.viewEvent.start = startDate;
            },

            get() {
                return moment(this.viewEvent.start).format('YYYY-MM-DD');
            }
        },
        endDate: {
            set(value) {
                const endDate = moment(value).toDate();
                setTimeForDate(endDate, this.duration.split('-')[1])
                this.viewEvent.end = endDate;
            },
        },
        startRecurringDate: {
            set(value) {
                const startDate = moment(value).toDate();
                setTimeForDate(startDate, this.duration.split('-')[0])
                this.startRecurringDate = startDate;
            },
        },
        endRecurringDate: {
            set(value) {
                const endDate = moment(value).toDate();
                setTimeForDate(endDate, this.duration.split('-')[1])
                this.endRecurringDate = endDate;
            }
        },

        formattedDisplayStartDate() {
            if (!this.hintDateHormat) return ''

            return moment(this.startDate).format(this.facility.dateFormat)
        },

        formattedDispayStartRecurringDate() {
            if (!this.hintDateHormat) return ''

            return moment(this.startRecurringDate).format(this.facility.dateFormat)
        },

        formattedDisplayEndRecurringDate() {
            if (!this.hintDateHormat) return ''

            return moment(this.endRecurringDate).format(this.facility.dateFormat)
        },

        formattedStartDate() {
            if (!this.hintDateHormat) return ''

            return moment(this.startDate).format(this.hintDateHormat)
        },

        formattedStartRecurringDate() {
            return moment(this.startRecurringDate).format(this.hintDateHormat)
        },

        formattedEndRecurringDate() {
            if (!this.endRecurringDate) return ''

            return moment(this.endRecurringDate).format(this.hintDateHormat)
        },

        duration: {
            get() {
                if (!this.durationVal) {
                    const startTime = moment(this.calendarEvent?.start).format(this.facility.timeFormat);
                    const endTime = moment(this.calendarEvent?.end).format(this.facility.timeFormat);
                    return `${startTime}-${endTime}`;
                }

                return this.durationVal;
            },
            set(value) {
                this.durationVal = value;
            },
        },

        recurringDuration: {
            get() {
                if (!this.calendarEvent?.isRecurring) return;

                if (!this.recurringDurationVal) {
                    const startTime = moment(this.calendarEvent?.start).format(this.facility.timeFormat);
                    const endTime = moment(this.calendarEvent?.end).format(this.facility.timeFormat);
                    return `${startTime}-${endTime}`;
                }

                return this.recurringDurationVal || '';
            },
            set(value) {
                this.recurringDurationVal = value;
            },
        },

        imageUrl: {
            get() {
                return this.calendarEvent?.imageUrl;
            },
            set(value) {
                this.viewEvent.imageUrl = value;
            },
        },
        name: {
            get() {
                if (this.calendarEvent.type === this.EventsTypesMinor.RealtimeCall || this.calendarEvent.type === this.EventsTypesMinor.ScheduledCall) {
                    return this.calendarEvent?.inviterName + " - " + this.calendarEvent?.name;
                } else {
                    return this.calendarEvent?.name;
                }
            },
            set(value) {
                this.viewEvent.name = value;
            },
        },
        location: {
            get() {
                return this.calendarEvent?.location;
            },
            set(value) {
                this.viewEvent.location = value;
            },
        },
        description: {
            get() {
                return this.calendarEvent?.description;
            },
            set(value) {
                this.viewEvent.description = value;
            },
        },
        isPublished: {
            get() {
                return this.calendarEvent?.isPublished;
            },
            set(value) {
                this.viewEvent.isPublished = value;
            },
        },
        wing: {
            get() {
                return this.calendarEvent?.wing;
            },
            set(value) {
                this.viewEvent.wing = value;
            },
        },
        attendees: {
            get() {
                return this.calendarEvent?.attendees;
            },
            set(value) {
                this.viewEvent.attendees = value;
            },
        },
        invitees: {
            get() {
                return this.calendarEvent?.invitees;
            },
            set(value) {
                this.viewEvent.invitees = value;
            },
        },
        start: {
            get() {
                return this.calendarEvent?.start;
            },
            set(value) {
                this.viewEvent.start = value;
            },
        },
        end: {
            get() {
                return this.calendarEvent?.end;
            },
            set(value) {
                this.viewEvent.end = value;
            },
        },
        VideoLink: {
            get() {
                return this.calendarEvent?.VideoLink;
            },
            set(value) {
                this.viewEvent.VideoLink = value;
            },
        },
        isVirtualEvent: {
            get() {
                return this.calendarEvent?.isVirtualEvent;
            },
            set(value) {
                this.viewEvent.isVirtualEvent = value;
            },
        },
        isPaidEvent: {
            get() {
                return this.calendarEvent?.isPaidEvent;
            },
            set(value) {
                this.viewEvent.isPaidEvent = value;
            },
        },
        isBroadcast: {
            get() {
                return this.calendarEvent.isBroadcast ?? false;
            },
            set(value) {
                this.viewEvent.isBroadcast = value;
            },
        },
        hostEmailAddress: {
            get() {
                return this.calendarEvent?.hostEmailAddress;
            },
            set(value) {
                this.viewEvent.hostEmailAddress = value;
            },
        },
        isExternallyHosted: {
            get() {
                return this.calendarEvent?.isExternallyHosted;
            },
            set(value) {
                this.viewEvent.isExternallyHosted = value;
            },
        },
        calendarEventType: {
            get() {
                return this.calendarEvent?.type;
            },
            set(value) {
                this.viewEvent.type = value;
            },
        },
        servicesListComputed() {
            let additionalServicesComputed = [];
            if (this.calendarEvent.type === this.eventTypesEnum.PremiumServices) {
                additionalServicesComputed = this.additionalServices;
            }
            if (this.calendarEvent.type === this.eventTypesEnum.LifestylePrograms) {
                additionalServicesComputed = this.socialClubsDropdown;
            }
            return additionalServicesComputed;
        },
        invitedService() {
            let additionalService = this.additionalServices.find(additionalService => this.invitees.includes(additionalService.id));
            if (!additionalService) {
                additionalService = this.socialClubsDropdown.find(additionalService => this.invitees.includes(additionalService.id));
            }
            if (!additionalService) {
                additionalService = "All";
            }
            return additionalService;
        },
        eventTypes() {
            return [...Object.values(EventsTypes)];
        },
        eventTypesEnum() {
            return EventsTypes;
        },
        convertToTranslationKey(text: string) {
            return toTranslationKey(text)
        },
        oneOffMembers() {
            const members = [];
            const result = this.invitedService?.membersList?.filter(x => {
                if (!members.find(member => member.id === x.id)) {
                    members.push(x);
                    return x.isOneOff;
                }
            });

            return result ? result : [];
        },
        notOneOffMembers() {
            const membersDaily = [];
            const result = this.invitedService?.membersList?.filter(x => {
                if (
                    x.isOneOff === false ||
                    (x.isOneOff === undefined &&
                        !membersDaily.find(member => member.id === x.id))
                ) {
                    membersDaily.push(x);
                    return !x.isOneOff;
                }
            });
            return result ? result : [];
        },
        availibleAttendance() {
            if(this.calendarEvent.type === EventsTypes.PremiumServices){
                return this.showAllAttendeesResidents === true
                ? this.residents.filter(resident => resident.status !== ResidentStatus.Departed)
                : this.residents.filter(resident => this.calendarEvent.going?.includes(resident.id) && resident.status !== ResidentStatus.Departed)
            }else{
                return this.residents.filter(resident => !this.calendarEvent.attendeesIds?.includes(resident.id) && resident.status !== ResidentStatus.Departed);
            }
        },
        selectedPremiumService() {
            return this.additionalServices.find(x => x.id === this.calendarEvent?.invitees[0]);
        },
        isShowEventTypeSelect() {
            return ![this.eventsTypes.PremiumServices, this.eventsTypes.ConciergeRequest].includes(this.calendarEvent.type);
        },
        isConciergeService() {
            return this.calendarEventType === this.eventTypesEnum.PremiumServices;
        },
        isLifestyleProgram() {
            return this.calendarEventType === this.eventTypesEnum.LifestylePrograms;
        },
        isRemoveMembers() {
            return Object.prototype.hasOwnProperty.call(this.calendarEvent, 'isRemoveMembers') && this.calendarEvent.isRemoveMembers;
        },
        isConciergeEvent() {
            return this.isConciergeService && this.calendarEvent?.hasOwnProperty('serviceId') && this.calendarEvent.serviceId.length;
        }
    },
    async created() {
        this.eventsTypesOptions = EventsTypesOptions.filter((x: any) => ![this.eventsTypes.PremiumServices, this.eventsTypes.ConciergeRequest].includes(x.value)).map(x => ({
            value: x.value,
            name: this.$t(x.name)
        }));
    },
    async mounted() {
        try {
            this.loading = true;
            const id = this.$route.params.id;
            await this.$store.dispatch('getFacility');
            await this.$store.dispatch('getCalenderEvent', id);
            await this.$store.dispatch('getCalenderRecurringEvents', id);
            await this.$store.dispatch('getAdditionalServices');
            await this.$store.dispatch('getSocialClubList');
            await this.$store.dispatch('getFamilyMembers');
            await this.$store.dispatch("getEventLocations");

            const dateFormat = dateFormats.find(x => x.format == this.facility.dateFormat)
            this.hintDateHormat = dateFormat ? dateFormat.name : dateFormats[0].name
            this.hintTimeHormat = this.facility.timeFormat.includes('A') ? this.facility.timeFormat.replace(' A', '') : this.facility.timeFormat

            if (this.calendarEvent?.attendees) {
                this.calendarEvent.attendees = this.calendarEvent.attendees.map(x => ({name: this.residents.find(a => a.id === x.id)?.pname || x.name, ...x}))
            }

            if (this.calendarEvent?.wingsIds?.length) {
                this.selectedWingsIds = this.calendarEvent.wingsIds;
            }

            await this.updateLocationValue(this.location, true);
            this.checkRouteParams();

            this.prevLocation = this.locations.find(x=>x.name === this.location)

        } catch (e) {
            console.error('mounted() error: ', e);
        } finally {
            // TODO make this code better
            this.loading = false;
            setTimeout(() => {
                this.$forceUpdate();
            }, 0)
        }
    },

    destroyed(): void {
        this.$store.commit('setCurrentCalenderEvent', null);
    },

    beforeRouteLeave(to, from, next) {
        next();
    },
    watch: {
        'calendarEvent.recurringRepetitions'(newValue) {
            if(newValue > 0){
                this.findMeetingTimesForRecurring()
            }
        },
        recurringEventsUpdated(events) {
            //detect updating seria and redirect to the new id of the first event in seria
            if (this.calendarEvent?.isRecurring && events.length > 0) {
                const now = moment(new Date()).toDate();
                const upcoming = events.filter(x => moment(x.end.seconds * 1000).toDate() >= now)
                    .sort((a, b) => moment(a.end.seconds * 1000).diff(moment(b.end.seconds * 1000)));

                this.redirectToEvent(upcoming[0].id);
            }
        },
        calendarRecurringEvents() {
            if (this.calendarRecurringEvents?.length > 0) {
                this.endRecurringDate = moment(this.calendarRecurringEvents[this.calendarRecurringEvents.length - 1].end).format('YYYY-MM-DD');
            }

            this.upcomingRecurringEvents = this.getUpcomingRecurringEvents();

            this.setEventDates();
        },
        calendarEvent(event) {
            if (event) {

                this.viewEventCopy = {...event};

                this.setEventDates();
            }
        },
        calendarEventType(eventType) {
            if (eventType !== this.eventsTypes.PremiumServices && this.calendarEvent) {
                this.calendarEvent.participantLimitNumber = null;
                this.calendarEvent.participantLimit = "";
            }
        },
        invitees() {
            if (this.selectedPremiumService?.participantLimit === this.premiumServiceParticipantsLimit.LimitPerEvent) {
                this.calendarEvent.participantLimitNumber = this.calendarEvent?.participantLimitNumber || 1;
                this.calendarEvent.participantLimit = this.premiumServiceParticipantsLimit.LimitPerEvent;
            } else {
                if (this.calendarEvent) {
                    this.calendarEvent.participantLimitNumber = null;
                    this.calendarEvent.participantLimit = "";
                }
            }
        },
        selectedWingsIds(newValue) {
            this.calendarEvent.wingsIds = newValue;
        }
    },
    methods: {
        addCurrentOffice365HourDurationToList(force){

            if(!this.isOffice365Event || this.isMsEventHourDurationInitialized === true && !force) return

            let duration = ''

            if(this.calendarEvent.isRecurring){
                duration = `${moment(this.calendarEvent.start).format(this.facility.timeFormat || 'HH:mm')}-${moment(this.calendarEvent.end).format(this.facility.timeFormat || 'HH:mm')}`
                if(!this.availableTimes.find(x=>x.value === duration)){
                    this.availableTimes.push({text: duration, value: duration})
                    this.recurringMeetingTimeSlot = duration
                }
                else if(this.recurringMeetingTimeSlot !== duration){
                    this.recurringMeetingTimeSlot = duration
                }
            }
            else{
                duration = moment(this.calendarEvent.start).format(this.facility.timeFormat || 'HH:mm')
                if(!this.availableTimes.find(x=>x.value === duration)){
                    this.availableTimes.push({text: duration, value: duration})
                    this.startTime = duration
                }
                else if(this.recurringMeetingTimeSlot !== duration){
                    this.startTime = duration
                }
            }

            this.isMsEventHourDurationInitialized = true
        },

        attendanceFilter(item, queryText, itemText) {
            const name = item.name.toLowerCase();
            const pname = (item.pname || '').toLowerCase();
            const searchText = queryText.toLowerCase();
            return name.includes(searchText) || pname.includes(searchText)
        },

        onInviteesChange(id) {
            this.invitees = [id]
        },

        onEventTypeChange() {
            this.calendarEvent.attendees = []
            this.calendarEvent.attendeesIds = []
            this.calendarEvent.goingDetails = [];
            this.calendarEvent.going = [];
        },

        setEventDates() {

            if (!this.calendarEvent) return;

            if (this.calendarEvent.isRecurring) {

                if (this.upcomingRecurringEvents.length > 0 && this.$route.params.editRecurringEventType === EditRecurringEventTypes.AllEvents) {
                    //set date of the first event in seria
                    this.startRecurringDate = moment(this.upcomingRecurringEvents[0].start).format('YYYY-MM-DD');
                } else {
                    //set date of the current event
                    this.startRecurringDate = moment(this.calendarEvent?.start).format('YYYY-MM-DD');
                }
            } else {
                //set date of the current event
                this.startDate = moment(this.calendarEvent?.start).format('YYYY-MM-DD');
            }
        },

        redirectToEvent(eventId) {
            if (eventId && eventId != this.$route.params.id) {
                const editType = this.editRecurringEventType && this.calendarEvent.isRecurring && this.viewEventCopy.isRecurring ? this.editRecurringEventType : (!this.calendarEvent.isRecurring && this.viewEventCopy.isRecurring ? '' : EditRecurringEventTypes.AllEvents)//;
                this.$router.push('/calendar/' + eventId + '/' + editType);
            }
        },

        getUpcomingRecurringEvents() {
            if (!this.calendarRecurringEvents) return [];

            const now = moment(new Date());
            const upcoming = this.calendarRecurringEvents.filter(
                x => moment(x.end) >= now
            );
            return upcoming;
        },

        routeToCalender() {
            const {residentId, isVideoCallEnabled} = this.$route.params;
            const params: any = {};

            if (residentId) {
                params.name = 'ResidentView';
                params.params = {id: residentId};
            } else {
                params.name = 'Calendar';
                params.params = {
                    isVideoCallEnabled,
                    currentWeek: this.calendarEvent.start,
                };
            }

            this.$router.push(params);
        },

        async saveEventImage(e) {
            const path = `${this.currentFacility}/events/coverImages/${uuidv4()}`;
            const file: File | Blob | any = await optimizePhotos(e.target.files[0], '');
            const fileSizeInMegabytes = fileSizeToMB(file?.size);

            if (!validFileSize10MB(fileSizeInMegabytes)) {
                this.$refs.inputUpload.value = null;
                return;
            }

            uploadImage({
                path,
                file,
                onStart: snapshot => {
                    this.eventImageUploadPerc =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                onComplete: async storageRef => {
                    const uploadedImageUrl = await storageRef.snapshot.ref.getDownloadURL();
                    const resizedImageRef = await firebase.storage().ref().child(`${path}_200x200`);

                    try {
                        const resizedImageUrl = await waitResizedImage(10, resizedImageRef);
                        this.viewEvent.imageUrl = uploadedImageUrl;
                        this.viewEvent.thumbnailUrl = resizedImageUrl;
                    } catch (e) {
                        this.viewEvent.imageUrl = uploadedImageUrl;
                        this.viewEvent.thumbnailUrl = uploadedImageUrl;
                    } finally {
                        this.eventImageUploadPerc = 100;
                    }
                },
                onError: e => {
                    console.error(e.message);
                },
            });
        },

        async setOffice365EventState(state) {
            this.isOffice365Event = state;

            this.updateMaxDate()
        },

        updateMaxDate(){
            if(this.isOffice365Event === true){
                if((this.calendarEvent.recurringType === RecurringEventsType.Monthly
                    || (this.calendarEvent.recurringType === RecurringEventsType.Custom && this.calendarEvent.recurringRepeatType === RecurringRepeatType.Month))){
                    this.maxDate = moment(this.startRecurringDate).add(1, "year").format('YYYY-MM-DD');
                }
                else{
                    this.maxDate = moment(this.startRecurringDate).add(50, "days").format('YYYY-MM-DD');
                }
            }
            else{
                this.maxDate = moment(new Date()).add(1, "year").format('YYYY-MM-DD');
            }
        },

        getEventColor(date){
            if (this.busyEventDates.includes(date) || this.msCalendarEvents.some(d => d.date === date && d.items.length > 0)) {
                return'orange';
            }
            else if (this.msCalendarEvents.some(d => d.date === date && d.items.length <= 0)) {
                return'green';
            }

            return 'white';
        },

        async loadMsCalendarEvents(){
            if(this.isOffice365Event) {
                const params = {
                    facilityId: this.currentFacility,
                    range: {
                        startDateTime: moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                        endDateTime: moment().endOf('day').add(1, 'month').format('YYYY-MM-DDTHH:mm:ss')
                    }
                }

                this.isLoadingMsCalendarEvents = true
                await this.$store.dispatch('msCalendarView', params).then(response => {
                    this.isLoadedMsCalendarEvents = true
                    if (response.data?.data?.length > 0) {
                        this.msCalendarEvents = response.data.data
                        this.eventDates = this.eventDates.concat(response.data.data.map(x=>x.date));
                        this.isLoadingMsCalendarEvents = false
                    }
                })
            }
        },

        async updateLocationValue(value: string, isInitFunc?: boolean): Promise<void> {

            this.currentRoomLocation = this.locations.find((location: { name: string }) => location.name === value);

            if (this.currentRoomLocation?.isInOffice365 === true) {
                this.newLocation = this.locations.find(x=>x.name === this.location)
                this.calendarEvent.office365Email = this.newLocation?.office365Email || null
                const locationEvents = this.calendarEvents.filter(ev => ev.location === value);
                const startTime = moment(this.calendarEvent.start).format(this.facility.timeFormat);
                const endTime = moment(this.calendarEvent.end).format(this.facility.timeFormat);
                this.durationMins = moment(endTime, this.facility.timeFormat).diff(moment(startTime, this.facility.timeFormat), 'minutes');
                console.log('current durationMins', this.durationMins)
                await this.setOffice365EventState(true);
                await this.findMeetingTimes(true);
                if (isInitFunc) {
                    const times = this.availableTimes[0]?.value === null ? [] : this.availableTimes;
                    this.availableTimes = [...times, {text: startTime, value: startTime}];
                    this.startTime = moment(this.calendarEvent.start).format(this.facility.timeFormat);
                }
                if (locationEvents.length > 0) {
                    locationEvents.forEach(event => {
                        const date = new Date(event.startISOString).toISOString().split('T')[0];
                        this.eventDates.push(date);
                        this.busyEventDates.push(date);
                    });
                }
                await this.loadMsCalendarEvents()
            } else {
                await this.setOffice365EventState(false);
            }
        },

        async findMeetingTimes(isInitFunc?: boolean, setCurrentHourDuration?: boolean): Promise<void> {

            if(!this.isOffice365Event) return

            if(this.calendarEvent.isRecurring){

                if(!this.startRecurringDate?.length || !this.endRecurringDate?.length) {
                    this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}]
                    return
                }
                else{
                    await this.findMeetingTimesForRecurring()
                }
            }
            else{

                if(!this.startDate?.length ) {
                    this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}]
                    return
                }
                else{
                    await this.findMeetingTimesForSingleEvent(isInitFunc)
                }
            }

            this.addCurrentOffice365HourDurationToList(setCurrentHourDuration)
        },

        async findMeetingTimesForSingleEvent(isInitFunc?: boolean): Promise<void> {

            if (!this.isOffice365Event) return

            this.isLoadingMeetingTimes = true

            const startDateTime = moment(this.startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
            
            const endDateTime = moment(this.startDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss');

            if (this.calendarEvent.startISOString && !isInitFunc) {
                this.startTime = moment(this.calendarEvent.start).locale(i18n.locale).format(this.facility.timeFormat);
                this.durationMins = this.durationMins > 0 ? this.durationMins : +moment(this.calendarEvent.end).locale(i18n.locale).format(this.facility.timeFormat).split(':')[0] - +this.startTime.split(':')[0];
            }

            if (this.isOffice365Event) {

                const params = {
                    roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
                    startDateTime,
                    endDateTime,
                    meetingDurationInMins: this.durationMins,
                    facilityId: this.currentFacility
                }

                return await this.$store.dispatch('findMsMeetingTimes', params)
                    .then(response => {
                        if (response.data?.data?.length > 0) {
                            this.availableTimes = response.data.data.map(el => {
                                const timeSlot = `${moment(el.meetingTimeSlot?.start.dateTime).format(this.facility.timeFormat)}`;
                                return {text: timeSlot, value: timeSlot}
                            });
                        } else {
                            this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}];
                        }
                    }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.isLoadingMeetingTimes = false
                })
            }
        },

        async findMeetingTimesForRecurring(): Promise<void> {

            if(!this.calendarEvent.isRecurring || !this.isOffice365Event){
                this.availableTimes = []
                return
            }

            this.updateMaxDate()

            let startDateTime = null
            let endDateTime = null


            if(this.editRecurringEventType === EditRecurringEventTypes.SelectedEvent){
                startDateTime = moment(this.startRecurringDate).startOf('day')
                endDateTime = moment(this.startRecurringDate).endOf('day')
            }
            else if(this.editRecurringEventType === EditRecurringEventTypes.CurrentAndfollowingEvents){
                startDateTime = moment(this.startRecurringDate).startOf('day')
                endDateTime = moment(this.endRecurringDate).endOf('day')
            }
            else if(this.editRecurringEventType === EditRecurringEventTypes.AllEvents){
                startDateTime = moment(this.calendarRecurringEvents[0]?.start).startOf('day')
                endDateTime = moment(this.calendarRecurringEvents[this.calendarRecurringEvents.length - 1].end).endOf('day')
            }
            else{
                this.availableTimes = []

                return;
            }

            this.isLoadingMeetingTimes = true

            const params = {
                roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
                office365ResourceEmail: this.currentRoomLocation?.office365Email || null,
                startDateTime: startDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                endDateTime: endDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                recurrence: {
                    repetitions:this.calendarEvent?.recurringRepetitions,
                    type: this.calendarEvent?.recurringType,
                    repeatType: this.calendarEvent?.recurringRepeatType,
                    repetitionsDays: this.calendarEvent?.recurringRepetitionsDays,
                    monthlyRepeatOn: this.calendarEvent?.monthlyRepeatOn,
                },
                meetingDurationInMins: this.durationMins,
                facilityId: this.currentFacility
            }

           return await this.$store.dispatch('findMsMeetingTimesForRecurring', params)
                .then(response => {
                    if (response.data) {
                        const meetingTimeSuggestions = response.data.data.meetingTimeSuggestions

                        if(meetingTimeSuggestions.length > 0){
                            this.availableTimes = meetingTimeSuggestions[0].times.map(time => {
                                return {text: time, value: time}
                            });
                        }
                        else{
                            this.availableTimes = []
                        }

                    } else {
                        this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}];
                    }
                }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.isLoadingMeetingTimes = false
            })
        },

        onRecurringRepeatTypeChanged() {
            this.findMeetingTimesForRecurring()
        },

        onRecurringRepetitionsDaysChanged() {
            this.findMeetingTimesForRecurring()
        },

        onRecurringTypeChanged(){
            if(this.calendarEvent.recurringType === RecurringEventsType.Custom){
                this.calendarEvent.recurringRepetitions = null
                this.calendarEvent.recurringRepeatType = null
                this.calendarEvent.recurringRepetitionsDays = null
            }

            this.findMeetingTimesForRecurring()
        },

        decrementDurationMins() {
      
            if (this.readonly) return

            if (!this.durationMins || this.durationMins <= 15) {
                this.durationMins = 15;
            }
            else {
                this.durationMins = +this.durationMins-15;
            }
    
            this.$forceUpdate();
            this.findMeetingTimes();
        },

        incrementDurationMins() {

            if (this.readonly) return

            if (!this.durationMins) {
                this.durationMins = 15;
            }
            else {
                this.durationMins = +this.durationMins+15;
            }
            this.$forceUpdate();
            this.findMeetingTimes();
        },

        checkAvailableTime(value) {
            this.isTimeRangeValid = !!value;
        },

        async publishEvent() {
            if (!this.viewEventCopy.isPublished) {
                let message = null

                if (this.editRecurringEventType === EditRecurringEventTypes.AllEvents) {
                    message = this.$t('ViewCalendarItem.PublishAllEventsQuestion')
                } else if (this.editRecurringEventType === EditRecurringEventTypes.CurrentAndfollowingEvents) {
                    message = this.$t('ViewCalendarItem.PublishThisAndFollowingEventsQuestion')
                } else if (!this.editRecurringEventType || this.editRecurringEventType === EditRecurringEventTypes.SelectedEvent) {
                    message = this.$t('ViewCalendarItem.PublishEventQuestion')
                } else {
                    throw new Error('Edit recurring event type not found')
                }

                await this.$refs.confirmationModal
                    .open(null, message, false)
                    .then(async response => {
                        if (response && response.agree) {
                            await this.updateEvent(true)
                        }
                    });
            } else {
                await this.updateEvent(true)
            }
        },

        onScheduldEventsDialogResponse(response) {
            this.saveAsDraft(response.isScheduled === true ? response.scheduledPublishDateTime : null)
            this.closeScheduldEventsDialog()
        },

        async onCancelCall(cancelReason){

            await this.$store.dispatch('cancelScheduldCall', { id: this.$route.params.id, cancelReason: cancelReason })
            
            this.$toast.open({
                message: this.$t('ViewCalendarItem.CallSuccessfullyCanceled'),
                type: "success"
            });

            delay(1000).then(() => {
                this.routeToCalender()
            });
        },

        async saveAsDraft(scheduledPublishDateTime) {

            if (this.viewEventCopy.isPublished) {
                let message = null

                if (this.editRecurringEventType === EditRecurringEventTypes.AllEvents) {
                    message = this.$t('ViewCalendarItem.UnPublishAllEventsQuestion')
                } else if (this.editRecurringEventType === EditRecurringEventTypes.CurrentAndfollowingEvents) {
                    message = this.$t('ViewCalendarItem.UnPublishThisAndFollowingEventsQuestion')
                } else if (!this.editRecurringEventType || this.editRecurringEventType === EditRecurringEventTypes.SelectedEvent) {
                    message = this.$t('ViewCalendarItem.UnPublishEventQuestion')
                } else {
                    throw new Error('Edit recurring event type not found')
                }

                await this.$refs.confirmationModal
                    .open(null, message, false)
                    .then(async response => {
                        if (response && response.agree) {
                            await this.updateEvent(false, scheduledPublishDateTime)
                        }
                    });
            } else {
                await this.updateEvent(false, scheduledPublishDateTime)
            }
        },

        async updateEvent(isPublished, scheduledPublishDateTime) {

            const validatedDateTime = this.validateDateTime();

            if (!validatedDateTime) return;

            this.saving = true

            if (isPublished) {
                this.viewEvent.scheduledPublishDateTime = null
            }

            this.viewEvent.scheduledPublishDateTime = scheduledPublishDateTime || null

            if (this.calendarEvent.isRecurring || this.viewEventCopy.isRecurring) {
                if (this.editRecurringEventType === EditRecurringEventTypes.SelectedEvent) {
                    await this.updateSingleEvent(isPublished)
                } else if (this.editRecurringEventType === EditRecurringEventTypes.CurrentAndfollowingEvents) {
                    await this.updateCurrentAndfollowingEvents(isPublished)
                } else {
                    await this.updateRecurringEvent(isPublished)
                }
            } else {
                await this.updateSingleEvent(isPublished)
            }

            if (this.additionalService?.eventId && this.additionalService?.eventId === this.$route.params.id) {
                await this.updateAdditionalService();
            }

            await this.loadMsCalendarEvents()

            this.saving = false
        },

        async updateCurrentAndfollowingEvents(isPublished) {

            await this.$refs.confirmationModal
                .open(null, this.getUpdateTextMessage(), false)
                .then(async response => {
                    if (response && response.agree) {

                        this.isPublished = isPublished

                        let recurringDuration = null

                        if (this.isOffice365Event) {
                            const meetingTimeSlots = this.recurringMeetingTimeSlot.split('-')
                            const splitStartTimeArray = convertTimeTo24HourInArray(meetingTimeSlots[0]);
                            const splitEndTimeArray = convertTimeTo24HourInArray(meetingTimeSlots[1]);
                            recurringDuration = convertTimeDurationTo24hFormat(`${splitStartTimeArray[0]}:${splitStartTimeArray[1]}-${splitEndTimeArray[0]}:${splitEndTimeArray[1]}`);
                            this.viewEvent.office365RoomName = this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name
                        }
                        else {
                            recurringDuration = convertTimeDurationTo24hFormat(this.recurringDuration)
                        }

                        const eventData = {
                            event: this.viewEvent,
                            recurringRange: {
                                duration: recurringDuration,
                                start: this.startRecurringDate,
                                end: this.endRecurringDate
                            },
                        };

                        await this.$store.dispatch('updateCurrentAndfollowingEvents', eventData).then((eventId) => {
                            this.redirectToEvent(eventId);
                        });
                        this.readonly = true;
                    }
                });
        },

        async updateRecurringEvent(isPublished) {

            await this.$refs.confirmationModal
                .open(null, this.getUpdateTextMessage(), false)
                .then(async response => {
                    if (response && response.agree) {

                        this.isPublished = isPublished

                        let recurringRange = null

                        //if event changed from recurring to single
                        if (this.viewEventCopy.isRecurring && !this.calendarEvent.isRecurring) {

                            //get time range
                            const timeRange = this.duration.split('-');
                            const startDate = new Date(this.startRecurringDate);
                            const endDate = new Date(this.startRecurringDate);

                            //set date to start date and set time
                            setTimeForDate(startDate, timeRange[0])
                            this.viewEvent.start = startDate;

                            //set time for end date
                            setTimeForDate(endDate, timeRange[1])
                            this.viewEvent.end = endDate;

                            this.viewEvent.duration = this.duration;
                        }

                        //if event changed from single to recurring
                        else if (this.calendarEvent.isRecurring && !this.viewEventCopy.isRecurring) {
                            recurringRange = {
                                duration: convertTimeDurationTo24hFormat(this.recurringDuration),
                                start: this.startRecurringDate,
                                end: this.endRecurringDate,
                            }
                        }

                        //if event is recurring and edited
                        else if (this.calendarEvent.isRecurring && this.viewEventCopy.isRecurring) {

                            let recurringDuration = convertTimeDurationTo24hFormat(this.recurringDuration);

                            if (!this.startRecurringDate) {
                                this.startRecurringDate = moment(this.calendarRecurringEvents[0]?.start).format(this.hintDateHormat);
                            }
                            if (!this.endRecurringDate) {
                                this.endRecurringDate = moment(this.calendarRecurringEvents[this.calendarRecurringEvents.length - 1].end).format(this.hintDateHormat);
                            }

                            if (this.isOffice365Event) {
                                const meetingTimeSlots = this.recurringMeetingTimeSlot.split('-')
                                const splitStartTimeArray = convertTimeTo24HourInArray(meetingTimeSlots[0]);
                                const splitEndTimeArray = convertTimeTo24HourInArray(meetingTimeSlots[1]);
                                recurringDuration = convertTimeDurationTo24hFormat(`${splitStartTimeArray[0]}:${splitStartTimeArray[1]}-${splitEndTimeArray[0]}:${splitEndTimeArray[1]}`);
                            }

                            recurringRange = {
                                duration: recurringDuration,
                                start: this.startRecurringDate,
                                end: this.endRecurringDate
                            }
                        }

                        if (this.isOffice365Event) {
                            this.viewEvent.office365RoomName = this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name
                        }

                        const eventData = {
                            event: this.viewEvent,
                            recurringRange: recurringRange
                        };

                        console.log('eventData: ', eventData)
                        await this.$store.dispatch('updateCalenderEvent', eventData).then((eventId) => {
                            this.redirectToEvent(eventId);
                        });
                        this.readonly = true;
                    }
                });
        },

        async updateSingleEvent(isPublished) { //pass copy to get prev time range
            this.isPublished = isPublished

            let startDate = null
            let endDate = null

            //get time range
            let timeRange = [];
            let recurringRange = null
            if (this.calendarEvent.isRecurring) {
                timeRange = this.recurringDuration.split('-');
                startDate = new Date(`${this.startRecurringDate}T00:00:00`);
                endDate = new Date(`${this.startRecurringDate}T00:00:00`);
                recurringRange = {
                    start: this.calendarRecurringEvents[0]?.start,
                    end: this.calendarRecurringEvents[this.calendarRecurringEvents.length - 1].end
                }

                if (this.isOffice365Event) {
                    timeRange = convertTimeDurationTo24hFormat(this.recurringMeetingTimeSlot).split('-')
                }

            } else {
                timeRange = this.duration.split('-');
                startDate = this.calendarEvent?.start;
                endDate = new Date(this.calendarEvent?.start);

                if (this.isOffice365Event) {
                    const newEndTime = moment(this.startTime, this.facility.timeFormat).add(this.durationMins, 'minutes')
                    const endTime = newEndTime.format(this.facility.timeFormat)
                    timeRange = [this.startTime, endTime];
                }
            }

           if (this.isOffice365Event) {
               this.calendarEvent.office365RoomName = this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name
            }

            //set date to start date and set time
            setTimeForDate(startDate, timeRange[0])
            this.calendarEvent.start = startDate;

            //set time for end date
            setTimeForDate(endDate, timeRange[1])
            this.calendarEvent.end = endDate;

            await this.$store.dispatch('updateSingleCalenderEvent', { event: this.viewEvent, recurringRange: recurringRange}).then(async (result) => {
                await this.$store.dispatch('getCalenderEvent', this.$route.params.id);
                this.readonly = true;

                if(this.isOffice365Event && this.calendarEvent?.office365EventId?.length && result.msEventUpdateResult.status !== 200){
                    this.$toast.error(this.$t("NewCalendarItem.ErrorUpdatingMsEvent") as string)
                }
            });
        },

        getUpdateTextMessage() {
            if (this.viewEventCopy.isRecurring && !this.calendarEvent.isRecurring) {
                return `Are you sure you want to change event from <br><b>recurring</b> to <b>single</b> ?`
            } else if (!this.viewEventCopy.isRecurring && this.calendarEvent.isRecurring) {
                return `Are you sure you want to change event from <b>single</b> to <b>recurring</b> ?`
            } else if (this.viewEventCopy.isRecurring && this.calendarEvent.isRecurring) {
                const editQuestionPart = `Are you sure you want to edit event series from <br>`
                const changedRange = `<b>${moment(this.startRecurringDate).format(this.facility.dateFormat)}</b> to 
        <b>${this.calendarEvent.noEndDate ? 'no end date' : moment(this.endRecurringDate).format(this.facility.dateFormat)}</b>`
                return `${editQuestionPart} ${changedRange} ?`
            }
        },

        deleteEvent() {
            if (this.calendarEvent.isRecurring) {
                this.isDeleteRecurring = !this.isDeleteRecurring;
                this.openEditRecurringEventOptionsDialog()
            } else {
                this.deleteSingleEvent();
            }
        },

        cancelCall(){
            (this.$refs.cancelCallDialog as any).open()
        },

        deleteSingleEvent() {
            this.saving = true
            setTimeout(() => {
                this.$refs.confirmationModal
                    .open(null, this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.DeleteEventMessage'], false)
                    .then(async response => {
                        if (response && response.agree) {
                           await this.$store.dispatch('deleteCalenderEvent', {  id: this.calendarEvent.id, isRecurring: this.calendarEvent?.isRecurring, office365EventId: this.calendarEvent?.office365EventId}).then(() => {
                                this.$router.push('/calendar');
                            });
                        }
                        this.saving = false
                    });
            }, 200)
        },

        deleteAllRecurringEvents() {
            this.saving = true
            this.$refs.confirmationModal
                .open(null, this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.DeleteEventSeriesMessage'], false)
                .then(async response => {
                    if (response && response.agree) {
                        this.$store.dispatch('deleteCalenderEventSeries', { parentEventId: this.calendarEvent.parentEventId, deleteUpcomingEvents: true});
                        this.$router.push('/calendar');
                    }
                    this.saving = false
                });
        },

        async deleteCurrentAndFollowingEvents() {
            this.saving = true

            this.$refs.confirmationModal
                .open(null, this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.DeleteCurrentAndFollowingsEventsMessage'], false)
                .then(async response => {
                    if (response && response.agree) {
                        await this.$store.dispatch('deleteCalenderEventSeriesByRange', {
                            parentEventId: this.calendarEvent?.parentEventId,
                            start: moment(this.startRecurringDate).startOf('date').toDate(),
                            end: moment(this.endRecurringDate).endOf('date').toDate()
                        })
                         .then(() => {
                            this.$router.push('/calendar');
                         });
                         this.saving = false
                    }
                });
        },

        deleteRecurringEvents() {
            if (this.editRecurringEventType === EditRecurringEventTypes.SelectedEvent) {
                this.deleteSingleEvent();
            } else if (this.editRecurringEventType === EditRecurringEventTypes.CurrentAndfollowingEvents) {
                this.deleteCurrentAndFollowingEvents();
            } else {
                this.deleteAllRecurringEvents();
            }
        },

        joinVirtualEvent() {
            // this.$router.push("/meeting/" + this.calendarEvent.id.toString());
            this.$router.push({
                name: 'Meeting',
                params: {
                    eventId: this.calendarEvent.id.toString(),
                    availibleAttendance: this.availibleAttendance,
                },
            });
        },

        editMode() {
            if (this.readonly) this.viewEvent = this.calendarEvent;
            this.readonly = !this.readonly;
            if (this.calendarEvent?.isRecurring) {
                this.isEditRecurring = true;
                this.openEditRecurringEventOptionsDialog();
            }
        },

        openEditRecurringEventOptionsDialog() {
            this.isOpenEditRecurringEventOptionsDialog = true;
            setTimeout(() => {
                this.$refs.editRecurringEventDialog.changeTitle({isDelete: this.isDeleteRecurring});
            }, 200)
        },

        async editRecurringOptionSelected(editRecurringEventType) {
            this.editRecurringEventType = editRecurringEventType;
            this.isOpenEditRecurringEventOptionsDialog = false;
            if (this.isDeleteRecurring) {
                this.deleteRecurringEvents();
            }
            if (this.isDuplicateRecurring) {
                this.duplicateRecurringEvents();
            }
            if (this.isEditRecurring) {
                this.editRecurringEventsDate();
            }

            await this.findMeetingTimes(false, true)
        },

        closeRecurringOptionSelected() {
            this.readonly = true;
        },

        isRecurringChanged(isRecurring) {
            if (isRecurring) {
                this.calendarEvent.recurringType = RecurringEventsType.Daily
                this.startRecurringDate = this.startDate
                this.recurringDuration = this.duration
            } else {
                this.calendarEvent.recurringType = null
                this.startDate = this.startRecurringDate
                this.duration = this.recurringDurationVal
                this.noEndDate = false
            }
        },

        allDayChange(value) {
            if (value) {
                if (this.facility.timeFormat.includes('A')) {
                    this.duration = '12:00 AM-11:59 PM';
                } else {
                    this.duration = '00:00-23:59';
                }
                this.noEndDate = false
            } else {
                const startTime = moment(this.calendarEvent?.start).format(this.facility.timeFormat);
                const endTime = moment(this.calendarEvent?.end).format(this.facility.timeFormat);
                this.duration = `${startTime}-${endTime}`;
            }
        },

        duplicateEvent() {
            if (this.calendarEvent.isRecurring) {
                this.isDuplicateRecurring = true;
                this.openEditRecurringEventOptionsDialog()
            } else {
                this.$router.push({
                    name: 'DuplicateCalendarItem',
                    params: {
                        duplicate: this.calendarEvent
                    }
                });
            }
        },

        duplicateRecurringEvents() {
            const eventData: any = {
                parentEventId: this.calendarEvent.parentEventId,
                recurringRange: {
                    duration: convertTimeDurationTo24hFormat(this.recurringDuration),
                    start: this.startRecurringDate,
                    end: this.endRecurringDate,
                },
            };
            this.$router.push({
                name: 'DuplicateCalendarItem',
                params: {
                    duplicate: this.calendarEvent,
                    editRecurringEventType: this.editRecurringEventType,
                    recurringData: eventData
                }
            });
        },

        editRecurringEventsDate() {
            if (this.editRecurringEventType === EditRecurringEventTypes.AllEvents) {
                const firstEvent = this.calendarRecurringEvents[0];
                this.startRecurringDate = moment(firstEvent.start).format('YYYY-MM-DD');
            }
        },

        async addAttendee() {
            const attendees = this.selectedAttendees.map(member => {
                return {
                    id: member.id,
                    name: member.name,
                    email: member?.email || null,
                    imageUrl: member.imageUrl || require('@/assets/no-image.jpg'),
                    pname: member.pname || ""
                };
            });

            const attendeesIds = this.selectedAttendees.map(({id}) => id);

            if (this.calendarEvent.attendees) {
                this.calendarEvent.attendees = [
                    ...this.calendarEvent.attendees,
                    ...attendees,
                ];
            } else {
                this.calendarEvent.attendees = attendees;
            }

            if (this.calendarEvent.attendeesIds) {
                this.calendarEvent.attendeesIds = [
                    ...this.calendarEvent.attendeesIds,
                    ...attendeesIds,
                ];
            } else {
                this.calendarEvent.attendeesIds = attendeesIds;
            }

            await this.$store.dispatch('updateSingleCalenderEvent', {
                event: this.calendarEvent,
                id: null
            });
            this.selectedAttendees = [];

            // The 'calenderAttendees' firebase function does the same on the db level
            // but it takes some time to triggered so here we need to remove added attendees
            // from 'One-Off Charge' UI list.
            if (this.invitedService?.membersList) {
                this.invitedService.membersList = this.invitedService?.membersList.filter(
                    x => !attendeesIds.includes(x.id)
                );
            }
        },

        addEventPhoto(e) {
            const path = `${this.currentFacility}/events/eventGalleries/${uuidv4()}`;
            const file = e.target.files[0];

            uploadImage({
                path,
                file,
                onStart: () => {
                    this.galeryImgLoading = true;
                },
                onComplete: storageRef => {
                    storageRef.snapshot.ref.getDownloadURL().then(url => {

                        this.calendarEvent.galleryPhotos = this.calendarEvent.galleryPhotos ? this.calendarEvent.galleryPhotos : [];

                        this.calendarEvent.galleryPhotos.push({
                            photoUrl: url,
                            hideForResidentsIds: [],
                            addedByStaffId: this.currentUserId
                        });

                        this.$forceUpdate();

                        this.$store.dispatch('updateSingleCalenderEvent', {
                            event: this.calendarEvent,
                            id: null,
                        });

                        this.galeryImgLoading = false;
                    });
                },
                onError: e => {
                    console.error(e.message);
                    this.galeryImgLoading = false;
                },
            });
        },

        setTime(start: string, end: string) {

            const beginningTime = moment(start, this.facility.timeFormat);
            const endTime = moment(end, this.facility.timeFormat);

            if (!beginningTime.isBefore(endTime)) {
                end = moment(start, this.facility.timeFormat).add(30, 'm').format(this.facility.timeFormat);
            }
            const duration = `${start}-${end}`;

            this.duration = duration;
        },

        onTimeRangeChange(timeRange) {
            this.validateDateTime()
            this.setTime(timeRange.startTime, timeRange.endTime)
            this.isTimeRangeValid = timeRange.isValid
            this.updateMaxDate()
        },

        onRecurringTimeRangeChange(timeRange) {
            this.validateDateTime()
            this.setRecurringTime(timeRange.startTime, timeRange.endTime)
            this.updateMaxDate()
        },

        setRecurringTime(start: string, end: string) {

            const beginningTime = moment(start, this.facility.timeFormat);
            const endTime = moment(end, this.facility.timeFormat);

            if (!beginningTime.isBefore(endTime)) {
                end = moment(start, this.facility.timeFormat).add(30, 'm').format(this.facility.timeFormat);
            }
            const duration = `${start}-${end}`;
            this.recurringDuration = duration;
        },

        validateDateTime() {

            if (this.calendarEvent.isRecurring) {
                const startRecurringDate = moment(this.startRecurringDate, 'YYYY-MM-DD');
                setTimeForDate(startRecurringDate, this.recurringDuration.split('-')[0])

                this.startDateValid = startRecurringDate.isValid();

                //for first set
                if (this.endRecurringDate == null) {
                    this.endDateValid = true;
                    this.endDateTimeValid = true;
                    return this.isDatesValid()
                }

                const endDate = moment(this.endRecurringDate, 'YYYY-MM-DD');
                setTimeForDate(endDate, this.recurringDuration.split('-')[1])

                this.endDateValid = endDate.isValid();
                if (this.endDateValid) this.endDateTimeValid = endDate > startRecurringDate;

                if (this.calendarEvent.noEndDate == true) {
                    this.endDateValid = true;
                    this.endDateTimeValid = true;
                }

                if (!this.calendarEvent.noEndDate) {
                    if (this.endRecurringDate > this.maxDate) {
                        this.endMaxDateValid = false;
                    } else {
                        this.endMaxDateValid = true;
                    }
                }
            } else {
                const startDate = moment(this.startDate, 'YYYY-MM-DD');
                setTimeForDate(startDate, this.duration.split('-')[0])
                this.startDateValid = startDate.isValid();
            }

            return this.isDatesValid()
        },

        isDatesValid() {
            return this.startDateValid && this.endDateValid && this.startDateTimeValid && this.endDateTimeValid && this.endMaxDateValid
        },

        addAllResidentsToAttendance() {
            this.selectedAttendees = this.availibleAttendance;
            this.addAttendee();
        },

        removeResidentFromAttendance(resident) {
            const indexAttendeesIds = this.calendarEvent.attendeesIds.findIndex(
                item => item === resident.id
            );
            const indexAttendees = this.calendarEvent.attendees.findIndex(
                item => item.id === resident.id
            );
            this.calendarEvent.attendeesIds.splice(indexAttendeesIds, 1);
            this.calendarEvent.attendees.splice(indexAttendees, 1);
            this.addAttendee();
        },

        checkRouteParams() {
            const routeParams = this.$route.params;

            if (routeParams.isEditEvent) {
                this.editMode();
            }

            if (routeParams.isDeleteEvent) {
                this.deleteEvent();
            }
        },

        cutString(str) {
            return str && str.length ? ((str.length > 25) ? str.slice(0, 22) + '...' : str) : ''
        },

        addLocation(type) {
            const form = {
                name: "",
                type: EventLocations.Other,
                facilityId: this.currentFacility
            };

            if (type === "select") {
                form.name = this.$refs.location.lazySearch;
            } else {
                form.name = this.location;
            }

            this.$store.dispatch("addEventLocation", form)
                .then(() => {
                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.LocationSuccessfullyAddedMessage'],
                        type: "success"
                    });
                }).catch((error) => {
                this.$toast.open({
                    message: `${error.message}`,
                    type: "error"
                });
            });
        },

        addWing(type) {
            const form = {
                name: "",
                type: EventLocations.Wing,
                facilityId: this.currentFacility
            };

            if (type === "select") {
                form.name = this.$refs.wings.lazySearch;
            } else {
                form.name = this.wing;
            }

            this.$store.dispatch("addEventLocation", form)
                .then(() => {
                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.LocationSuccessfullyAddedMessage'],
                        type: "success"
                    });
                }).catch((error) => {
                this.$toast.open({
                    message: `${error.message}`,
                    type: "error"
                });
            });
        },

        decrementParticipantLimitNumber(): void {
            if (this.calendarEvent.participantLimitNumber > 1) {
                this.calendarEvent.participantLimitNumber--;
                this.$forceUpdate();
            }

            if (!this.calendarEvent.participantLimitNumber) {
                this.calendarEvent.participantLimitNumber = 1;
                this.$forceUpdate();
            }
        },

        incrementParticipantLimitNumber(): void {
            if (!this.calendarEvent.participantLimitNumber) {
                this.calendarEvent.participantLimitNumber = 1;
            } else {
                this.calendarEvent.participantLimitNumber++;
            }
            this.$forceUpdate();
        },

        openGalleryPhotos() {
            this.isOpenEventPhotoGallery = false;
            (this.$refs.GalleryPhotosUploadDlg as any).open();
        },

        openEventGalleryPhotos() {
            this.isOpenEventPhotoGallery = true;
            (this.$refs.GalleryPhotosUploadDlg as any).open();
        },

        uploadGalleryPhoto(image: GalleryImage) {
            if (this.isOpenEventPhotoGallery) {
                this.calendarEvent.galleryPhotos = this.calendarEvent.galleryPhotos ? this.calendarEvent.galleryPhotos : [];
                this.calendarEvent.galleryPhotos.push({
                    photoUrl: image.image,
                    thumbnailUrl: image?.thumbnailUrl ?? image.image,
                    hideForResidentsIds: [],
                    addedByStaffId: this.currentUserId
                });
                this.$store.dispatch('updateSingleCalenderEvent', {
                    event: this.calendarEvent,
                    id: null,
                });
            } else {
                this.calendarEvent.imageUrl = image.image;
                this.calendarEvent.thumbnailUrl = image.thumbnailUrl;
            }
        },

        async updateAdditionalService() {
            await firebase
                .firestore()
                .collection("additionalServices")
                .doc(this.additionalService.id)
                .update({
                    imageUrl: this.calendarEvent.imageUrl,
                    name: this.name,
                    description: this.description,
                    start: this.calendarEvent.start,
                    end: this.calendarEvent.end,
                    location: this.location,
                    wing: this.wing,
                    wingsIds: this.calendarEvent.wingsIds
                })
        },

        openScheduldEventsDialog() {
            this.isOpenScheduldEventsDialog = true
        },

        closeScheduldEventsDialog() {
            this.isOpenScheduldEventsDialog = false
        },

        openConciergeService(id) {
            this.$router.push("/concierge-service/" + id);
        },

        removeRepeatOption(index) {
            this.calendarEvent.monthlyRepeatOn.splice(index, 1);
        },

        addRepeatOption() {
            this.calendarEvent.monthlyRepeatOn.push(
              {
                  "position": RecurringRepeatOnNumber.First,
                  "day": RecurringRepeatOnDay.Monday
              }
            )
        }
    },
};
